<app-tab-router [items]="items" *ngIf="items && items.length > 0"></app-tab-router>

<div class="mb-2" *ngIf="items && items.length > 0"></div>
<router-outlet></router-outlet>